import { render, staticRenderFns } from "./client-search.vue?vue&type=template&id=8a9c3fac&"
import script from "./client-search.vue?vue&type=script&lang=js&"
export * from "./client-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports